<template>
  <el-dialog
    title="选择对比节点"
    :visible="modalOpen"
    :append-to-body="true"
    width="1000px"
    :before-close="handleModalCancel"
  >
    <div class="add-data-node pagination-table-container">
      <el-table
        ref="table"
        :data="tableData"
        border
        height="400px"
        @selection-change="handleTableSelectionChange"
        style="width: 100%">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="名称" prop="name"></el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleTableCurrentChange"
        :current-page.sync="tableQueryParams.pageNum"
        :page-sizes="[5, 10, 20]"
        :page-size="tableQueryParams.pageSize"
        prev-text="上一页"
        next-text="下一页"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotalRow">
      </el-pagination>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleModalSubmit" type="primary">确定</el-button>
      <el-button @click="handleModalCancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import AddDataNode from './AddDataNode.js'
export default AddDataNode
</script>

<style lang="scss">
// @import "AddDataNode.scss";
</style>



// WEBPACK FOOTER //
// src/views/common/showDataNode/addDataNode/AddDataNode.vue